import { Module } from 'vuex'
import {inspirations as inspirationsApi, RequestItemBag} from '@/api'

export const inspirations: Module<{}, {}> = {
  namespaced: true,

  actions: {
    async listing(_, query: RequestItemBag = {}) {
      return await inspirationsApi.list(query['page'] ?? 1, query['query'] ?? { listAll: true, withoutContent: true })
    },
    async find(_, id) {
      const response = await inspirationsApi.find(id, { withoutCache: true })

      return response.data
    },
    async create(_, data) {
      await inspirationsApi.create(data)
    },
    async update(_, { id, ...data }) {
      await inspirationsApi.update(id, data)
    },
    async delete(_, id) {
      await inspirationsApi.delete(id)
    },
  },
}
